<div *ngIf="showTitle" [ngClass]="getLevelClass()">
  <div class="row">
    <basic-label [noIndent]="true" [ngClass]="{ 'select--readonly': isReadonly }"></basic-label>
    <ng-container *ngIf="!isServer; else serverSelectInput">
      <div
        class="select select--block"
        [ngClass]="{
          'select--disabled': isDisabled || disableConditionally,
          'select--readonly': isReadonly
        }"
      >
        <ng-container *ngTemplateOutlet="clientSelectinput"></ng-container>
      </div>
    </ng-container>
  </div>
</div>

<div
  *ngIf="!showTitle"
  class="select"
  [ngClass]="{
    'select--disabled': isDisabled || disableConditionally,
    'select--readonly': isReadonly
  }"
>
  <ng-container *ngIf="isServer; then serverSelectInput; else clientSelectinput"></ng-container>
</div>

<ng-template #serverSelectInput>
  <div>
    <label *ngIf="label" class="entry-field__label">
      {{ label }}
    </label>
  </div>
  <div type="text" disabled class="entry-field__input" [ngClass]="getClasses()">{{ selectedItem }}</div>
</ng-template>

<ng-template #clientSelectinput>
  <div class="input-label-container">
    <input
      class="select__input"
      #selectInput
      id="{{ componentId + '_input' }}"
      [ngModel]="selectedItem"
      readonly
      (keyup)="keyUpPress($event)"
      (keydown)="keyDownPress($event)"
      (blur)="handleBlur()"
      [placeholder]="placeholder ? placeholder : 'Select'"
      [class.select--error__input]="isError()"
      [class.entry-field--error__input]="isError()"
      [disabled]="isDisabled || disableConditionally"
    />
    <label
      *ngIf="label"
      class="entry-field__label"
      for="{{ componentId }}"
      [class.entry-field--error__label]="isError()"
      [class.entry-field--filled__label]="!isError() && !!selectedItem"
    >
      {{ label }}
    </label>
  </div>
  <ul
    *ngIf="showDropdown"
    #dropdownUl
    class="select__box"
    [ngClass]="getClasses()"
    [class.select__box--label]="label"
    id="{{ componentId }}"
  >
    <li
      class="select__item"
      *ngFor="let option of options; let i = index"
      id="{{ questionItem.id + '_' + option.value }}"
      [class.select__item--selected]="i === selectedIndex"
      (click)="trigger(option)"
    >
      {{ option.description }}
    </li>
  </ul>
  <p class="error-message error-message--entry-field" *ngIf="isError()">
    {{ errorMessage[property] }}
  </p>
</ng-template>
